import React from "react";
import { connect } from "react-redux";
import { setCloudProvider } from "../../containers/CloudProvider/Store";

const CloudProviderSwitcher = ({ selectedProvider, setCloudProvider }) => {
  const handleProviderChange = (e) => {
    setCloudProvider(e.target.value);
    window.location.reload();
  };

  return (
    <div className="cloud-provider-switcher">
      <select
        value={selectedProvider}
        onChange={handleProviderChange}
        className="form-control custom-dropdown"
        style={{
          minWidth: "140px",
          fontSize: "14px",
          fontWeight: "500",
          cursor: "pointer",
        }}
      >
        <option value="azure">Azure</option>
        <option value="gcp">Google Cloud</option>
      </select>
    </div>
  );
};

const mapStateToProps = ({ CloudProviderStore }) => ({
  selectedProvider: CloudProviderStore
    ? CloudProviderStore.selectedProvider
    : "azure",
});

const mapDispatchToProps = {
  setCloudProvider,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CloudProviderSwitcher);
